module.exports = __webpack_public_path__ + "img/ic_team_youtube_white.e700be1e.svg";